const OurTeamCard = ({ data }) => {
  return (
    <div
      key={`teamList${data?.id}`}
      className='ourTeamCard bg-white rounded-lg shadow-md p-3 flex flex-col justify-center items-center border-2 border-transparent hover:border-eventLightYellow'>
      <img src={data?.image} alt='teamImg' />
      <h3 className='text-center pt-2 font-semibold text-lg'>{data?.name}</h3>
      <p className='text-center text-base text-eventGray font-light'>
        {data?.designation}
      </p>
    </div>
  );
};

export default OurTeamCard;
